import auto from '../i18n/auto.json';

export const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'zh', name: '简体中文', flag: '🇨🇳' }
];

export const HTML_LANG = {
  fr: 'fr',
  en: 'en',
  de: 'de',
  it: 'it',
  es: 'es',
  zh: 'zh-Hans'
};

const lookup = (lang, source) => (auto[lang] ? auto[lang][source] : undefined);

// Inline trilingual literals already present in the codebase (FR/EN/DE),
// extended to the other languages through the generated dictionary.
export const tx = (lang, fr, en, de) => {
  if (lang === 'fr') return fr;
  if (lang === 'en') return en;
  if (lang === 'de') return de;
  return lookup(lang, fr) || en;
};

// French-only source string translated through the generated dictionary.
export const tr = (lang, fr) => (lang === 'fr' ? fr : lookup(lang, fr) || fr);

export const localizeDeep = (value, lang) => {
  if (lang === 'fr') return value;
  if (typeof value === 'string') return lookup(lang, value) || value;
  if (Array.isArray(value)) return value.map((item) => localizeDeep(item, lang));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, localizeDeep(item, lang)])
    );
  }
  return value;
};
